import { i18n } from '../translate/i18n';
export const roleNames = (name) => roleToPortuguese(name);

const roleToPortuguese = (role) => {
    role = role ? role.toLowerCase() : role;
    switch (role) {
        case 'doorman':
            return i18n.t('roleNames.doorman');
        case 'analyst':
            return i18n.t('roleNames.analyst');
        case 'contractor':
            return i18n.t('roleNames.contractor');
        case 'admin':
            return i18n.t('roleNames.admin');
        case 'superadmin':
            return i18n.t('roleNames.superadmin');
        default:
            return 'função genérica'
    }
}


export const rolesText = access => {
    let roleName = roleNames(access.role);
    if (access.role === 'contractor') {
      roleName += ` (${access.company && access.company.name})`
    }
    return roleName
}
